/* Add Edit Goal First Component */
import React from "react";
import ReactDOM from "react-dom";
import { withTranslation } from 'react-i18next';
import AddGoal from "./okr/wizard/addGoal.component";
import DeleteCommonModal from "./deleteCommonModal.component";
import ConvertOKRmodal from "./okr/modals/convert-okr";
import GoalServices from "../services/goal.services";

import { hot } from "react-hot-loader/root";
import { ThemeProvider, Button, Menu, MenuItem } from '@workboard/wobo-ui';
import { KeyDownEvent } from '../utils/eventKey';

class AddOkrComponent extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    const { t } = this.props
    this.state = {
      escBtnEn: true,
      doneBtnEn: !!(
        this.props.addOkrData.goalDetails &&
        this.props.addOkrData.goalDetails.id
      ),
      moreOptionGoal: false,
      deleteGoalList: false,
      showConvertOKRModal: false,
      deleteTitle: t("Exit without saving"),
      deleteContentOne: t("Are you sure you want to"),
      buttonText: t("Exit"),
      goalType:
        this.props.addOkrData.goalDetails &&
        this.props.addOkrData.goalDetails.type
          ? this.props.addOkrData.goalDetails.type
          : this.props.addOkrData.myGoal
          ? "2"
          : "1",
      goalHeaderName: this.props.addOkrData.myGoal ? ` ${t('Personal Objective and Key Results')} ` : ` ${t('Team Objective and Key Results')} `,
      escBtnFuncEn: false,
      fromEsc: false,
      goalText: "",
      emptyKrText: "",
      goalOperation: "",
      deleteKrList: false,
      deletedGoal: false,
      anchorEl: null
    };
    this.handleGoalDoneChange = this.handleGoalDoneChange.bind(this);
    this.deleteGoal = this.deleteGoal.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.deleteItems = this.deleteItems.bind(this);
    this.unmountGoalComp = this.unmountGoalComp.bind(this);
    this.disableEscFunc = this.disableEscFunc.bind(this);
    this.enableEscFunc = this.enableEscFunc.bind(this);
    this.GoalServices = new GoalServices();
    this.clickEvent = this.clickEvent.bind(this);
    this.closeGoal = this.closeGoal.bind(this);
    this.goalTextWithOutsave = this.goalTextWithOutsave.bind(this);
    this.krTextWithOutsave = this.krTextWithOutsave.bind(this);
    this.emprtyKrName = this.emprtyKrName.bind(this);
    this.closeConvertOKRModal = this.closeConvertOKRModal.bind(this);
    this.moreActionsKeyboardHandler = this.moreActionsKeyboardHandler.bind(this);
    this.refetchObjectiveData = this.refetchObjectiveData.bind(this);
  }

  refetchObjectiveData(skipDelay = false) {
    const goalId = this.props.addOkrData?.goalDetails?.id;
    if (!goalId || !this.props.actions?.updateEditedOkr) return;
    const fetchData = () => {
      this.GoalServices.editKr({ goalId }).then((response) => {
        const goalDetails = response?.data?.goalDetails ?? response?.data?.data?.goalDetails;
        if (goalDetails && Object.keys(goalDetails).length) {
          this.props.actions.updateEditedOkr({ data: goalDetails });
        }
      }).catch(() => {});
    };
    if (skipDelay) {
      fetchData();
    } else {
      setTimeout(fetchData, 150);
    }
  }

  closeConvertOKRModal() {
    this.setState({ showConvertOKRModal: false });
  }

  escFunction(event) {
    // bug no WW-3237
    /*
		if (event.keyCode === 27 && this.state.escBtnFuncEn && this.state.goalText != ''
		  && !this.props.addOkrData.goalDetails) {
		  //Do whatever when esc is pressed
		  this.setState({ deleteGoalList: true, fromEsc: true });
		} else if(event.keyCode === 27 && this.state.escBtnFuncEn && this.state.goalText != ''
		  && this.props.addOkrData.goalDetails &&  !this.props.addOkrData.goalDetails.id){
			this.setState({ deleteGoalList: true, fromEsc: true });
		}
		if (event.keyCode === 27 && this.state.escBtnFuncEn && this.state.emptyKrText != '' && this.props.addOkrData.goalDetails.id) {
		  //Do whatever when esc is pressed
		  this.setState({ deleteGoalList: true, fromEsc: true });
		}
		*/

    // closes the 'Add Objective' screen on escape
    // if (event.key === 'Escape') {
    //   if (!document.getElementById('create-ws-wobo-modal-label')) {
    //     this.closeGoal()
    //   }
    // }
  }

  componentDidMount() {
    this._isMounted = true;
    $(window).scrollTop(0);
    document.addEventListener("keydown", this.escFunction, false);
    document.addEventListener("mousedown", this.clickEvent, false);
    window.addEventListener("krDataRefresh", this.refetchObjectiveData);
    if(this.props.addOkrData && this.props.addOkrData.display_kr_clustering &&
      (this.props.addOkrData.goalDetails && this.props.addOkrData.goalDetails.id)) {
      this.GoalServices.getClusterData({ goalId: this.props.addOkrData.goalDetails.id }).then(response => {
        if (response.status === 200) {
          this.props.actions.updateClusterData(response.data.data);
        }
      })
    }
    return overflowFunction(true);
  }

  goalTextWithOutsave(goalName) {
    this.setState({ goalText: goalName, escBtnFuncEn: goalName != "" });
  }

  emprtyKrName() {
    this.setState({ emptyKrText: "" });
  }

  krTextWithOutsave(KrNameText) {
    this.setState({ emptyKrText: KrNameText, escBtnFuncEn: KrNameText != "" });
  }

  clickEvent(e) {
    if (
      !$(".moreDoneOption").is(e.target) && // if the target of the click isn't the container...
      $(".moreDoneOption").has(e.target).length === 0
    ) {
      if (this._isMounted) {
      // this.setState({
      //   moreOptionGoal: false
      // });
    }
  }
  }

  componentWillUnmount() {
    this._isMounted = false;
    document.removeEventListener('keydown', this.escFunction, false);
    window.removeEventListener("krDataRefresh", this.refetchObjectiveData);
  }

  handleGoalDoneChange() {
    if (
      this.props.addOkrData.goalDetails &&
      typeof this.props.addOkrData.goalDetails.id !== "undefined"
    ) {
      this.setState({ escBtnEn: false, doneBtnEn: true });
    } else {
      this.setState({ escBtnEn: true, doneBtnEn: false });
    }
  }

  deleteGoal() {
    this.setState({ deleteGoalList: false });
  }

  exitDeleteModal() {
    this.setState({ deleteGoalList: false, deleteKrList: false });
  }

  deleteItems(id) {
    const _that = this;
    if (id != "" && id != undefined) {
      this.GoalServices.deleteObjective({ goalId: id }).then(response => {
        if (response.status === 200) {
          _that.setState({
            goalOperation: "delete",
            emptyKrText: "",
            deletedGoal: true
          });

          _that.unmountGoalComp(true);
        }
      });
    } else {
      setTimeout(() => {
        _that.setState({ deleteKrList: false, emptyKrText: "" });
      }, 0);

      setTimeout(() => {
        _that.unmountGoalComp(false);
      }, 100);
    }
  }

  unmountGoalComp(check = false) {
    const curGoalId = (this.props.addOkrData && this.props.addOkrData.goalDetails) ? this.props.addOkrData.goalDetails.id : null;
    if (this.state.emptyKrText != "") {
      const _this = this;
      setTimeout(() => {
        _this.setState({ deleteKrList: true });
      }, 10);
      return;
    } else {
      try {
        this.updateGoalPage(check);
        let unmountedNode = document.getElementById("add_goal_page");
        if (unmountedNode) {
          ReactDOM.unmountComponentAtNode(unmountedNode);
        }
        unmountedNode = null;
        addGoalDialog.dialog('close');
        $('body').css('overflow', 'visible');
        if($("#otherPriority").length && !$('.okr-list').length)
        {
            window.location.reload();
        }
      } catch (error) {
        $('body').css('overflow', 'visible');
      }
    }
    if (typeof curGoalId !== "undefined" && curGoalId && curGoalId != "") {
      if (
        $(".goalpageRender #otherPriority").length ||
        $(".notgoalpageRender #otherPriority").length
      ) {
        var selected = $("#otherPriority").tabs("option", "active");
        if (selected != 1) {
          if ($(".teamgoals[data-goal-id='" + curGoalId + "']").length) {
            $("html, body").animate(
              {
                scrollTop: $(
                  ".teamgoals[data-goal-id='" + curGoalId + "']"
                ).offset().top
              },
              250
            );
          }
        } else {
          if ($(".goal-table-row[data-goal-id='" + curGoalId + "']").length) {
            $("html, body").animate(
              {
                scrollTop: $(
                  ".goal-table-row[data-goal-id='" + curGoalId + "']"
                ).offset().top
              },
              250
            );
          }
        }
      } else if ($(".goalpageRender #fullAlignmentRender").length) {
        if (
          $("#fullAlignmentRender .goalName[goal_id='" + curGoalId + "']")
            .length
        ) {
          $("html, body").animate(
            {
              scrollTop: $(
                "#fullAlignmentRender .goalName[goal_id='" + curGoalId + "']"
              ).offset().top
            },
            250
          );
        }
      } else {
        if ($(".goal-table-row[data-goal-id='" + curGoalId + "']").length) {
          $("html, body").animate(
            {
              scrollTop:
                $(".goal-table-row[data-goal-id='" + curGoalId + "']").offset()
                  .top - 100
            },
            250
          );
          if (this.props.addOkrData.fromPage && this.props.addOkrData.fromPage == "fromOKRPopup") {
            var params = {};
            params.id = curGoalId;
            params.reload= Math.random();
            viewGoalDetailsPage(undefined, params);
          }
        }else{
          if ($("[data-goal-id='" + curGoalId + "']").length) {
            $("html, body").animate(
              {
                scrollTop:
                  $("[data-goal-id='" + curGoalId + "']").offset()
                    .top - 100
              },
              250
            );
          } else {
            $("html, body").animate(
              {
                scrollTop:
                  $(".wbContent").offset()
                    .top - 100
              },
              250
            );
          }
          if (this.props.addOkrData.fromPage && this.props.addOkrData.fromPage == "fromOKRPopup") {
            const queryString = window.location.search;
            const refSrc = new URLSearchParams(queryString).get('refSrc');
            var params = {};
            params.id = curGoalId;
            params.reload= Math.random();
            if (refSrc) {
              params.refSrc = refSrc;
            }
            viewGoalDetailsPage(undefined, params);
          }
        }
      }
      if(this.props.addOkrData.src === 'copyGoal') {
        var params = {};
        params.id = curGoalId;
        params.reload= Math.random();
        viewGoalDetailsPage(undefined, params);
      }
    }

    if (this.props.addOkrData.goalDetails) {
      const goalDetailsType = '';
      const {
        start_date, target_date, type, owner_id, team_id, id,
      } = this.props.addOkrData.goalDetails;
      const timePeriod = `${start_date} - ${target_date}`;

      if (type === '1') {
        goalDetailsType = 'Team';
      }

      if (type === '2') {
        goalDetailsType = 'Personal';
      }

      window.wb_track('OKR_ADD', {
        UserId: window.uData.user_id,
        OrgId: window.uData.org_id,
        Timestamp: Date.now(),
        TeamId: team_id,
        Type: goalDetailsType,
        OwnerId: owner_id,
        ObjectiveId: id,
        TimePeriod: timePeriod,
        Source: 'OKR_Wizard',
      });
    }
  }

  updateGoalPage(checkStatus = false) {
    if (
      this.props.addOkrData.goalDetails &&
      this.props.addOkrData.goalDetails.id
    ) {
      if (this.state.goalOperation) {
        updateRecentItemsTopMenu(
          this.props.addOkrData.goalDetails.id,
          "recent_goal",
          this.props.addOkrData.goalDetails.goal
        );
      }

      const goalId = this.props.addOkrData.goalDetails.id;
      if (
        goalId &&
        this.props.addOkrData.goalDetails.fromDetailPopup &&
        !this.state.deletedGoal
      ) {
        var params = {};
        params.id = goalId;
        viewGoalDetailsPage(undefined, params);
      }
      if ($('#mywobo-kr-wrapper').length) {
        var krId = $('#mywobo-kr-wrapper').attr('kr-id');
        if (typeof krId !== 'undefined') {
          setTimeout(() => {
            triggerKrDetailsCompReload(krId);
          }, 10);
        }
      }
      if ($(".mywobo-page-wrapper").length) {
        setTimeout(() => {
          $(document).trigger("rbr_reload_comp", [
            { reload: true, comp: ["metrics", "goals", "hotbox"] }
          ]);
        }, 50);
      }
      if (this.state.deletedGoal) {
        topmenuDeleteObject("goal", goalId, "goal");
      }
    }

    const element = document.getElementById("goal_index_page");
    if (
      element &&
      this.props.addOkrData.goalDetails &&
      this.props.addOkrData.goalDetails.id
    ) {
      const goalId = this.props.addOkrData.goalDetails.id;
      if (goalId) {
        if (checkStatus) {
          /** **
           * If the id is defined, the goal is created and the this.state.goalOperation can not be new
           */
          const goalOperationValue = this.state.goalOperation;
          // if(goalOperationValue == 'new'){
          //  goalOperationValue = 'reloadTab';
          // }

          if(typeof window.MyGoalContainer !== "undefined"){
            window.MyGoalContainer.updateGoalItems({ action: goalOperationValue || "edit", goalId });
          }
        }
        if (
          this.props.addOkrData.goalDetails.fromDetailPopup &&
          !this.state.deletedGoal
        ) {
          var params = {};
          params.id = goalId;
          viewGoalDetailsPage(undefined, params);
        }
      }
    } else if (
      this.props.addOkrData.goalDetails &&
      this.props.addOkrData.goalDetails.id
    ) {
      const goalId = this.props.addOkrData.goalDetails.id;
      return viewGoalPageReload(goalId);
    }
  }

  disableEscFunc() {
    this.setState({ escBtnFuncEn: false });
  }

  enableEscFunc() {
    this.setState({ escBtnFuncEn: true });
  }

  closeGoal() {
    if (this.state.goalText != "") {
      this.setState({ deleteGoalList: true, fromEsc: true });
    } else {
      this.unmountGoalComp();
    }
  }
  moreActionsKeyboardHandler(e){
    this.setState({ moreOptionGoal: !this.state.moreOptionGoal, anchorEl: e.target });
  }
	render() {
    const { t } = this.props;
		const goalData = this.props.addOkrData.goalDetails;
    const allowPersonalOkr = this.props.addOkrData.isAddPersonalObjectiveEnabled || false;
    const goalId = goalData ? goalData.id : undefined;
		const { managingTeamCount = 0} = this.props.addOkrData;
		let { goalHeaderName } = this.state;
		if (goalId) {
			goalHeaderName = (goalData.type == '2') ? ` ${t('Personal Objective and Key Results')} ` : ` ${t('Team Objective and Key Results')} `;
		}
		let orgIconStyle = {};
		const { org_icon = '' } = this.props.addOkrData;
		if (org_icon) {
			orgIconStyle.backgroundImage = `url('${org_icon}')`;
			orgIconStyle.backgroundRepeat = 'no-repeat';
    }
    let convertOkrsOption = '', DeleteAction = '';
    if (goalId){
      convertOkrsOption = ( managingTeamCount > 0 ) && allowPersonalOkr ? `${t('Convert to')} ${(goalData.type == '2' ? t('Team') + ` ` + t('OKR') : t('Personal OKR')) } `
      : goalData.type == '2' ?  `${t('Convert to Team OKR')}` : '';
      DeleteAction =  goalData.isTeamManagerOrCoManagerOrTeam == 1 && t("Delete");
    }
		return (
      <div id="mainAddGoalDiv">
				<div className="objectHeader " role="banner">
					<div style={{display: "flex"}}>
						<div className="addGoalWbIcon" role="img" aria-label="Workboard Logo" style={orgIconStyle} />
						<div className="mainGoalHeader" id="mainGoalHeader" tabIndex="-1" role="heading" aria-level="1">
							{t('Add')} {goalHeaderName}
            </div>
						{
							(this.state.escBtnEn && goalId === undefined)
							&& (
								<div className="closeBtnArea">
                  <div>
                    <div className="emptyBtn">&nbsp;</div>
                    <button className="closeGoal no-border"
                    onClick={this.closeGoal}
                    aria-label="close" />
                  </div>
								</div>
							)
						}
						{
							(this.state.doneBtnEn && goalId !== undefined)
							&& (
								<div className="inLineBlk moreDoneOption" style={{display: "flex"}} data-testid="moreDoneOption">
						  	<ThemeProvider>
                    <Button
                      kind="normal"
                      onClick={(e) => this.moreActionsKeyboardHandler(e)}
                      variant="secondary"
                      data-testid="goalMoreOption"
                      className="moreActionsDropdown"
                      endIcon={
                        <i className="icon icon-outline-keyboard_arrow_down-24px">
                        </i>}>
                         {t('More actions')}
                  						{
											this.state.moreOptionGoal
											&& (
                        <Menu
                            anchorOrigin={{
                              horizontal: 'left',
                              vertical: 'bottom'
                            }}
                            id="myAlign-moreActions"
                            keepMounted
                            transformOrigin={{
                              horizontal: 'left',
                              vertical: 'top'
                            }}
                            open={this.state.moreOptionGoal}
                            onClose={() => this.setState({ moreOptionGoal: false })}
                            anchorEl={this.state.anchorEl}
                            data-testid="myAlign"
                          >
                            { allowPersonalOkr && (
                            <MenuItem onClick={ () => {
                              this.setState({ showConvertOKRModal: true });
                              this.setState({ moreOptionGoal: false })
                              }}>
                             {convertOkrsOption}
                            </MenuItem>
                            )}
                            <MenuItem onClick={() =>{
                               this.setState({ deleteGoalList: true });
                               this.setState({ moreOptionGoal: false });
                               } } >
                             {DeleteAction}
                            </MenuItem>
                          </Menu>
											)
										}
									</Button>
                    <div className="inLineBlk">
                          <Button
                            aria-label="Done"
                            variant="primary"
                            className="woboGoalDoneBtn"
                            data-testid="goalDoneBtn"
                            onClick={()=>this.unmountGoalComp(true)}>
                                {t('Done')}
                          </Button>
                    </div>
                </ThemeProvider>
                </div>
							)
						}
					</div>
					{
						(this.state.escBtnEn && goalId === undefined)
						&& (
							<div className="EscDiv" style={{ display: 'none' }}>
								<div className="textEscDiv" />
								<div className="EscClass " onClick={this.closeGoal}>{t('ESC')}</div>
							</div>
						)
					}
					{
						(this.state.escBtnEn && goalId === undefined)
						&& (
							<div className="EscDiv" style={{ display: 'none' }}>
								<div className="dotEscDiv" />
								<div className="EscDott " onClick={this.closeGoal} />
							</div>
						)
					}
				</div>
				<div className="addOkrContent" role="main">
					<AddGoal
						handleGoalDoneChange={this.handleGoalDoneChange}
						{...this.props}
						goalType={this.state.goalType}
						disableEscFunc={this.disableEscFunc}
						enableEscFunc={this.enableEscFunc}
						unmountGoalComp={this.unmountGoalComp}
						goalTextWithOutsave={this.goalTextWithOutsave}
						krTextWithOutsave={this.krTextWithOutsave}
						addOkrObject={this}
						emprtyKrName={this.emprtyKrName}
						onOpenEditObjective={() => this.refetchObjectiveData(true)}
					/>
				</div>
				{
					this.state.deleteGoalList
					&& (
						<DeleteCommonModal
							exitDeleteModal={this.exitDeleteModal}
							deleteItems={this.deleteItems}
							title={this.props.addOkrData.goalDetails && this.props.addOkrData.goalDetails.id ? t('Delete OKR? ') : this.state.deleteTitle}
							deleteContentOne={this.state.deleteContentOne}
							deleteContentSecond={this.props.addOkrData.goalDetails && this.props.addOkrData.goalDetails.id ? t('Delete OKR') : t('leave without saving your OKR?')}
							deleteContentBodyText={this.props.addOkrData.goalDetails && this.props.addOkrData.goalDetails.id ? t('Are you sure you want to delete this OKR? The objective and all associated key results will be deleted (except linked key results).') : t('Are you sure you want to leave without saving?')}
							buttonText={this.state.buttonText}
							id={this.props.addOkrData.goalDetails && this.props.addOkrData.goalDetails.id ? this.props.addOkrData.goalDetails.id
								: ''}
							deletefirstTitle={t('Delete OKR')}
							deleteContentSecondParam={t('delete OKR?')}
						/>
					)
				}

      { this.state.showConvertOKRModal && allowPersonalOkr && (
          <ConvertOKRmodal
            isOpen={this.state.showConvertOKRModal}
            goalDetails={this.props.addOkrData.goalDetails}
            closeModal={this.closeConvertOKRModal}
            updateOKR={this.props.actions.updateEditedOkr}
            okr_disabled_org_perm={this.props.addOkrData.okr_disabled_org_perm}
          />
        )}

        {this.state.deleteKrList && (
          <DeleteCommonModal
            exitDeleteModal={this.exitDeleteModal}
            deleteItems={this.deleteItems}
            id=""
            title={t("Exit without saving")}
            deleteContentOne=""
            deleteContentSecondParam=""
            deletefirstTitle=""
            deleteContentSecond={t('Are you sure you want to leave without saving your key result?')}
            buttonText={t("Exit")}
          />
        )}
      </div>
    );
  }
}

export default hot(withTranslation()(AddOkrComponent));
